module.exports = __webpack_public_path__ + "img/52ne.c8fb52af.svg";